import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import InscriptionsAdmin from './Inscriptions';
import InscriptionsSeller from './InscriptionsSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function InscriptionsAdminIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <InscriptionsAdmin />
			break;
		case '2':
			component = <InscriptionsSeller />
			break;
		case '3':
			component = <InscriptionsSeller />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
